export default {
  classRoom: {
    id: '',
    degreeId: null,
    subjectGroupId: null,
    classRoomOwnedId: null,
    courseOutlineRegistrationId: null,
    classSectionId: null,
    sectionNo: null,
    teacherId: null,
    teacherCode: '',
    subjectId: null,
    subjectCode: '',
    nameLocal: '',
    nameEng: '',
    studentQty: null,
    capacity: null,
    startDate: '',
    endDate: '',
    isAvailable: null,
    isActive: null,
    classRoomTypeId: null,
  },
  classRooms: [],
  processing: false,
  error: null,
  success: null,
}



